import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const uploadProjectBridgeReport = api(async function uploadProjectBridgeReport({ fileName, fileData }) {
    return mutate(
        gql`
            mutation UploadProjectBridgeReport($fileName: String!, $fileData: String!) {
                uploadProjectBridgeReport(fileName: $fileName, fileData: $fileData)
            }
        `,
        { fileName, fileData },
        { returns: "uploadProjectBridgeReport" }
    )
})
